import Skeleton from "react-loading-skeleton";
import {
  DarkSkeletonTheme,
  ImageBone,
  TextBlock,
  TitleSkeleton,
} from "./shared";

const BranchBlockSkeleton = ({ imageTall = true }: { imageTall?: boolean }) => (
  <>
    <hr className="border-black border-t-1 mt-8" />
    <section className="bg-empty pt-16 px-10 lg:px-24">
      <div className="mb-8 lg:mb-0 flex justify-center lg:justify-start">
        <TitleSkeleton />
      </div>
      <div className="flex flex-col-reverse lg:flex-row justify-between gap-8">
        <div className="mt-8 lg:pr-40 flex-1 min-w-0 flex flex-col gap-4">
          <TextBlock lines={4} />
          <Skeleton height={22} width={140} />
        </div>
        <ImageBone
          className={`mx-auto lg:mx-0 shrink-0 aspect-square ${
            imageTall
              ? "h-40 lg:h-64"
              : "h-32 lg:h-52"
          }`}
        />
      </div>
    </section>
  </>
);

const BrancheSkeleton = () => (
  <DarkSkeletonTheme>
    <div className="mt-24 lg:mt-56" aria-busy="true" aria-live="polite">
      <section className="bg-empty pt-16 px-10 lg:px-24">
        <div className="mb-8 lg:mb-0 flex justify-center lg:justify-start">
          <Skeleton className="max-w-xl w-full" height={36} />
        </div>
        <div className="mt-8 lg:pr-40">
          <TextBlock lines={4} />
        </div>
      </section>
      <BranchBlockSkeleton />
      <BranchBlockSkeleton />
      <BranchBlockSkeleton />
      <div className="pb-16">
        <BranchBlockSkeleton imageTall={false} />
      </div>
    </div>
  </DarkSkeletonTheme>
);

export default BrancheSkeleton;
